<div [ngClass]="openDashboardFormPopup? '' : 'noShadowOverlay'"
     style="height: 100%; display: flex; flex-direction: column; overflow: hidden">

  <dx-drawer
    (onInitialized)="subscribeToWindowResize()"
    [style.opacity]="(!!dashboardService.userDashboards && !loadingData)? 1 : 0"
    #drawerComponent
    [(opened)]="openDashboardFormPopup"
    [className]="'drawerParent'"
    [closeOnOutsideClick]="false"
    [height]="'100%'"
    [openedStateMode]="'overlap'"
    [position]="'right'"
    [revealMode]="'slide'"
    template="template">

    <!--   INSIDE THE DRAWER     -->
    <!--   INSIDE THE DRAWER     -->
    <!--   INSIDE THE DRAWER     -->
    <!--   INSIDE THE DRAWER     -->

    <div *dxTemplate="let data of 'template'"
         [style.width.px]="setWidthOfDrawerPx()">

      <div *ngIf="openDashboardFormPopup" class="dashboardDrawerWrapper">
        <div class="drawerTitleWrapper">
          <h2 *ngIf="dashboardForForm.id !== undefined">{{ "DASHBOARD_FORM.UPDATE_TITLE" | translate }}</h2>
          <h2 *ngIf="dashboardForForm.id === undefined">{{ "DASHBOARD_FORM.CREATE_TITLE" | translate }}</h2>
          <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
            <dx-button (onClick)="formDrawerComponent.checkAndSaveDashboard()"
                       *ngIf="formDrawerComponent.editMode || dashboardForForm.id === undefined"
                       [disabled]="!formDrawerComponent.isDashboardFormValid() " [type]="'default'" icon="save"
                       text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
            <dx-button (onClick)="formDrawerComponent.revertDashboard(); formDrawerComponent.editMode = false;"
                       *ngIf="formDrawerComponent.editMode && dashboardForForm.id !== undefined"
                       [type]="'normal'" [stylingMode]="'contained'" icon="revert" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
            <dx-button (onClick)="openDashboardFormPopup = false; drawerComponent.instance.hide()"
                       [type]="'default'" [width]="30" icon="close"></dx-button>
          </div>
        </div>

        <app-dashboard-form
          #formDrawerComponent
          (closeDialog)="selectNewDashboard($event); openDashboardFormPopup = false;"
          [options]="options"
          [dashboard]="dashboardForForm">
        </app-dashboard-form>
      </div>
    </div>

    <!--   OUTSIDE THE DRAWER     -->
    <!--   OUTSIDE THE DRAWER     -->
    <!--   OUTSIDE THE DRAWER     -->
    <!--   OUTSIDE THE DRAWER     -->


    <div *ngIf="!loadingData && dashboardService.userDashboards.length === 0"
         class="unselectable relativePageContainer noDashboardAvailable" style="flex-direction: row">
      <img alt="Keton-logo-inntea-angolo" class="cornerImage" height="600" ngSrc="assets/Keton-logo-inntea-angolo.png"
           priority
           width="600">
      <div>
        <h3 style="text-align: center; margin-top: 0;">{{ (dashboardService.isImpersonatingUser() ? "DASHBOARD.NO_DASHBOARD_AVAILABLE_OTHER_USER" : "DASHBOARD.NO_DASHBOARD_AVAILABLE") | translate }}</h3>
        <dx-button
          *ngIf="!dashboardService.isImpersonatingUser()"
          (onClick)="openCreateDashboard()"
          [disabled]="loadingData"
          [elementAttr]="{class:'outlinedRedButton'}"
          [title]="'Crea gruppo'"
          [type]="'default'"
          [width]="'100%'"
          hint="{{'BUTTONS.HINTS.CREATE_METRIC_GROUP' | translate}}">
          <i class="vr-ic_fluent_add_24_regular"></i>
          <span>{{ 'BUTTONS.ADD' | translate }}</span>
        </dx-button>
      </div>
    </div>

    <div *ngIf="!loadingData && dashboardService.userDashboards.length > 0 && dashboard?.length === 0"
         class="unselectable relativePageContainer noDashboardAvailable" style="flex-direction: row">
      <img alt="Keton-logo-inntea-angolo" class="cornerImage" height="600" ngSrc="assets/Keton-logo-inntea-angolo.png"
           priority
           width="600">
      <div>
        <h3 style="text-align: center; margin-top: 0;">{{ (dashboardService.isImpersonatingUser() ? "DASHBOARD.NO_WIDGET_AVAILABLE_OTHER_USER" : "DASHBOARD.NO_WIDGET_AVAILABLE") | translate }}</h3>
        <dx-button
          *ngIf="!dashboardService.isImpersonatingUser()"
          (onClick)="openEditDashboard()"
          [disabled]="loadingData"
          [elementAttr]="{class:'outlinedRedButton'}"
          [title]="'Crea gruppo'"
          [type]="'default'"
          [width]="'100%'"
          hint="{{'BUTTONS.HINTS.CREATE_METRIC_GROUP' | translate}}">
          <i class="vr-ic_fluent_add_24_regular"></i>
          <span>{{ 'BUTTONS.ADD' | translate }}</span>
        </dx-button>
      </div>
    </div>


    <gridster #gridsterComponent [options]="options"
              *ngIf="!!dashboardService.userDashboards &&  dashboardService.userDashboards.length > 0 && dashboard && dashboard.length > 0">
      <ng-container *ngFor="let item of dashboard trackBy indexTrackBy">
        <gridster-item (transitionend)="dispatchSizeRefreshEvent()"
                       *ngIf="!!item"
                       [item]="item"
                       class="dx-card">

          <app-multi-chart-widget
            *ngIf="item.type === WidgetEnum.MULTI_CHART"
            (editItem)="editItemOptions($event, item)"
            (removeItem)="removeItem($event, item)"
            [editMode]="dashboardService.dashboardEditMode"
            [gridsterItem]="item"
            class="widgetContainer">
          </app-multi-chart-widget>

          <app-measure-cards
            *ngIf="item.type === WidgetEnum.METRIC_CARDS"
            (editItem)="editItemOptions($event, item)"
            (removeItem)="removeItem($event, item)"
            [editMode]="dashboardService.dashboardEditMode"
            [gridsterItem]="item"
            class="widgetContainer">
          </app-measure-cards>

          <app-three-dim-model
            *ngIf="item.type === WidgetEnum.THREE_DIM_MODEL"
            (editItem)="editItemOptions($event, item)"
            (removeItem)="removeItem($event, item)"
            [editMode]="dashboardService.dashboardEditMode"
            [gridsterItem]="item"
            class="widgetContainer">
          </app-three-dim-model>

        </gridster-item>
      </ng-container>
    </gridster>

  </dx-drawer>
</div>
